import { ElementType } from 'react';
import Button from '@ramsey-design-system/button';
import { ArrowRightIcon } from '@ramsey-design-system/icons';
import { useMatcherButtonSize } from '../utils';

function MatcherStandardNextButton({
  buttonText = 'Next',
  icon = ArrowRightIcon,
  iconPosition = 'right'
}: Readonly<{
  buttonText?: string;
  icon?: ElementType;
  iconPosition?: 'left' | 'right';
}>) {
  const buttonSize = useMatcherButtonSize();

  return (
    <Button
      data-testid="matcher_standard_next_button"
      type="submit"
      icon={icon}
      iconPosition={iconPosition}
      className={'!w-full'}
      fullWidthOnMobile={true}
      size={buttonSize}
    >
      {buttonText}
    </Button>
  );
}

export { MatcherStandardNextButton };
